export const LogLevel = {
  info: 'info',
  warning: 'warning',
  error: 'error'
};